import { isNumber, isString } from 'lodash-es';

const hexToDecimal = (hex: Numberlish) => {
  if (!isString(hex) && !isNumber(hex)) return NaN;

  if (isString(hex))
    return hex.length ? Number(`0x${hex.trim().replace(/^0x/i, '')}`) : NaN;

  return hex;
};

export default hexToDecimal;
